var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentProfileIconAct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New Project") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAYlQTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////35Pg3QAAAIN0Uk5TACHG9GIDUOu3KgoQZ/V/1Cu+h+17CAQPcsrP4ehA+dXz2uPHwnQFWVyI51jXoEVs8FOVqkv4w7sSoWCZfhoTSHCvKCmG0OQvAnfeRjk8tL2sqYNfswHSTVJo2yINnz+e3dPW4nMlPebJLYrFFyPsVRiOwAb6l6OQsCB4C8Qev+r80RSNA/35AAABQElEQVR4nGNkAAJGIPjDAAasIPZ3kBgDAxcjugQj4ysGRnEICyHxTBoioP6T4yvPZ0bezxAJvvdv1CASRoxnGUyA9EmIhAXjq1e6xxiENBmtP11mUOPmZjwMkWCwu6Z97TWDw29GazZGkBv+M8AAmMn0ndH6hhEDJmD8CtWBDkA6gHZATef8zbYDygbZAZVgdbn+2EiUcSuGhM9VacF/zIzvD6FLBDBevcVge8ngILqEK+86oHmGsmvRJUJuaqxmsJNgXIkuEfHp707WEEbGpegSMU/v2T15/8RkB6qEhxjjd1C8zE9inI0ikQaMEKY76u+Ed3gyTkGSyGVknAjxWQHj0VNIEkIJfbBQKmb8MQUsUcrYxcBQztgBDz8Dz3YGhqqDjCl/pFsxJNTCDjDWMk41YrDaKAqXsH702KZNIhkA4NJ/VIAUaDYAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1 copy",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfileIconAct);
export default __webpack_public_path__ + "static/media/student-profile-icon-act.940c378c79cf7f77190c40292f085544.svg";
export { ForwardRef as ReactComponent };